import React from "react";
import { Link } from "react-router";
import Slider from "./slider";
import { useSelector } from "react-redux";
import AboutNew from "./aboutNew";
import HomeServicesNew from "./HomeServicesNew";
import AnnouncementBar from "./Announcement";
import TotalData from "./TotalData";



const MainContent: React.FC<{ hlanguage: any, allImagesLink:any }> = ({ hlanguage, allImagesLink }) => {
    // const hlanguage = useSelector((state:any)=>state.auth.homeLanguage,);
const[role, setRole]=React.useState("");

  // Modal state
  const [showTraderModal, setShowTraderModal] = React.useState(false);
  const quickLinks = [
    {
      icon: "users",
      title: hlanguage.trader_reg,
      role:"Trader",
      desc: hlanguage.tra_desc,
    },
    {
      icon: "users",
      title: hlanguage.panel_reg,
      role:"Panel_Engineer",
      desc: hlanguage.panel_desc,
    },
    {
      icon: "users",
      title: hlanguage.gca_reg,
      role:"General_Commission_Agent",
      desc: hlanguage.gca_desc,
    },
  ];
  const handleSSOSignUp = (role)=>{
      
    const returnurl =`https://uat-eapmc.thesaicomputers.com/ssoLogin/${role}`;
    const accesskey = "b6e01c1d689344ad9b412200fb365cc3";

    const combined = `${returnurl}||${accesskey}`;
    const base64Encoded =  btoa(combined)
   
    window.location.href = `https://gujaratsso.gujarat.gov.in/CitizenSSORegistration/UserForm?redirectUrl=${base64Encoded}`;
  }
  const numbers = [
    { number: "450+", label: "Market Yards" },
    { number: "2.5L+", label: "Registered Traders" },
    { number: "₹50K Cr", label: "Annual Trade Volume" },
    { number: "5M+", label: "Farmers Benefited" },
  ];

  return (
    <>
      <main id="main-content" className="bg-white">
        {/* slider */}
        <div className="slider-wrapper">
          <Slider hlanguage={hlanguage} allImagesLink={allImagesLink}/>

          {/* <div className="slider-overlay">
        <div className="row text-white text-center align-items-center">
          <div className="col-4">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/home/computer.png`}
              className="overlay-icon"
              alt=""
            />
            <p className="overlay-text">Digital AMC Infrastructure</p>
          </div>

          <div className="col-4">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/home/store.png`}
              className="overlay-icon"
              alt=""
            />
            <p className="overlay-text">Efficient Market Administration</p>
          </div>

          <div className="col-4">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/home/shield_lock.png`}
              className="overlay-icon"
              alt=""
            />
            <p className="overlay-text">Secure & Transparent System</p>
          </div>
        </div>
          </div> */}
        </div>



        {/* <section
          className="py-5 text-black text-center"
          style={{
            background:
              "white",
          }}
          
        >
          <div className="container py-4">
            <h4 className="display-5 fw-bold mb-3">
              {hlanguage.g2}
            </h4>
            <p className=" fs-16 mb-4">
          {hlanguage.g_home}
            </p>
          </div>
        </section>

        <section
          className="container"
          style={{ marginTop: "-3rem", position: "relative", zIndex: 10 }}
        >
          <div className="row g-4 justify-content-center">
            {quickLinks.map((item, idx) => (
              
              <div key={idx} className="col-md-6 col-lg-3">
                <div className="card rounded-4 h-100 text-center border-0">
                       <button className="text-black rounded-4 h-100"
                       style={{
                        background: "#c5ffaaff", 
                        border: "none",
                      }}
                      onClick={()=>{
                        setRole(item.role);
                        setShowTraderModal(true);
                      }}
                      >
                  <div className="card-body p-4">
                    <i
                      className={`fas fa-${item.icon} fw-bold text-success mb-3`}
                      style={{ fontSize: "3rem" }}
                    ></i>
                    <h3 className="h5 fw-bold text-black mb-2">
                      {item.title}
                    </h3>
                    <p className="text-black mb-0">{item.desc}</p>
                  </div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section> */}
        <div className="my-5">
          <AnnouncementBar hlanguage={hlanguage} />
        </div>

        <HomeServicesNew hlanguage={hlanguage} allImagesLink={allImagesLink} />


        <div id="about-us" className="pb-5" style={{backgroundColor:"#FAECC0"}}>
          
        </div>
        <div >
          <AboutNew hlanguage={hlanguage} allImagesLink={allImagesLink}/>
        </div>
        <TotalData hlanguage={hlanguage} allImagesLink={allImagesLink}/>

      </main>
          <style>
      {`
        .slider-wrapper {
          position: relative;
          overflow: visible;
        }

        /* ===== Overlay default (Desktop) ===== */
        .slider-overlay {
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          width: 60%;
          background: #7F6201F0;
          padding: 1.5rem 2rem;
          z-index: 10;
          box-shadow: 0 15px 40px rgba(0,0,0,0.3);
        }
          .overlay-icon {
          height: 48px;
          margin-bottom: 8px;
        }

        .overlay-text {
          font-size: 1rem;
          font-weight: 500;
          margin: 0;
        }

        /* ===== Tablet ===== */
        @media (max-width: 992px) {
          .slider-overlay {
            width: 90%;
            bottom: -50px;
            padding: 1.25rem;
          }
              .overlay-icon {
            height: 40px;
          }

          .overlay-text {
            font-size: 0.9rem;
          }
        }

        /* ===== Mobile ===== */
        @media (max-width: 768px) {
          .slider-overlay {
            position: relative;        /* KEY CHANGE */
            bottom: 0;
            left: 0;
            transform: none;
            width: 100%;
            border-radius: 0;
            margin-top: -5px;          /* slightly overlaps slider */
            box-shadow: none;
          }
              .overlay-icon {
            height: 30px;
            margin-bottom: 4px;
          }

          .overlay-text {
            font-size: 0.75rem;
            line-height: 1.2;
          }

          .slider-overlay {
            padding: 0.75rem 0.5rem;
          }
        }
      `}
    </style>
    </>
  );
};

export default MainContent;
